// import { getInvestmentHoldings } from '../../../actions/yodlee';

/*
Not sure how this will look yet but assuming something like:
{
  [ACCOUNT_ID]: investment holdings
}
and it will respond to `getInvestmentHoldings` action
*/
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type;

  switch (type) {
    default:
      return state;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9yZWR1Y2Vycy95b2RsZWUvaW52ZXN0bWVudC1ob2xkaW5ncy5qcyJdLCJuYW1lcyI6WyJzdGF0ZSIsInR5cGUiXSwibWFwcGluZ3MiOiJBQUFBOztBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EsZ0JBQWUsWUFBMEI7QUFBQSxNQUF6QkEsS0FBeUIsdUVBQWpCLEVBQWlCOztBQUFBO0FBQUEsTUFBWEMsSUFBVyxRQUFYQSxJQUFXOztBQUN2QyxVQUFRQSxJQUFSO0FBQ0U7QUFDRSxhQUFPRCxLQUFQO0FBRko7QUFJRCxDQUxEIiwic291cmNlc0NvbnRlbnQiOlsiLy8gaW1wb3J0IHsgZ2V0SW52ZXN0bWVudEhvbGRpbmdzIH0gZnJvbSAnLi4vLi4vLi4vYWN0aW9ucy95b2RsZWUnO1xuXG4vKlxuTm90IHN1cmUgaG93IHRoaXMgd2lsbCBsb29rIHlldCBidXQgYXNzdW1pbmcgc29tZXRoaW5nIGxpa2U6XG57XG4gIFtBQ0NPVU5UX0lEXTogaW52ZXN0bWVudCBob2xkaW5nc1xufVxuYW5kIGl0IHdpbGwgcmVzcG9uZCB0byBgZ2V0SW52ZXN0bWVudEhvbGRpbmdzYCBhY3Rpb25cbiovXG5leHBvcnQgZGVmYXVsdCAoc3RhdGUgPSB7fSwgeyB0eXBlIH0pID0+IHtcbiAgc3dpdGNoICh0eXBlKSB7XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBzdGF0ZTtcbiAgfVxufTtcbiJdfQ==